"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("../state");
exports.default = (function (stepPanes) {
    var getActivePane = function () { return stepPanes.filter(function (pane) { return pane.classList.contains('is-active'); }); };
    var activePane = getActivePane();
    var paneFrame = document.querySelector('.FindAnAdvisor__body');
    if (!paneFrame) {
        return;
    }
    if (activePane) {
        state_1.setState({ activePaneElement: activePane[0] });
    }
    var animatePaneTransition = function (previousPane, nextPane, direction) {
        var TRANSITION_TIMING = 485; // Adding 10ms on to the transition timing
        var activeTransitions = state_1.state.transitioningPanes;
        // - - - - - - - - - - - - - - - -
        // The chores
        nextPane.classList.add('is-active');
        state_1.setState({ activePaneElement: nextPane });
        // Check that we aren't already transitioning out of this pane. Just in case.
        // This is an edge case when someone clicks out of and back into this pane within the 
        //   duration of TRANSITION_TIMING.
        if (activeTransitions.includes(nextPane)) {
            // Rather than cancel the offending timeout, which would mean storing it in state.
            // we will just plan to add it back after TRANSITION_TIMING has elapsed.
            // The duration is fast enough that it doesn't have a vusual issue.
            setTimeout(function () {
                nextPane.classList.add('is-active');
            }, TRANSITION_TIMING);
        }
        else {
            // If we aren't already transitioing this pane, then add it to the state as transitioning
            state_1.setState({ transitionPanes: activeTransitions.push(nextPane) });
        }
        // - - - - - - - - - - - - - - - -
        // The animations
        // Cleanup functions after we are done transitioning
        setTimeout(function () {
            previousPane.classList.remove('is-active');
            state_1.setState({ transitionPanes: activeTransitions.filter(function (pane) { return pane != nextPane; }) });
        }, TRANSITION_TIMING);
        if (direction == 'PREV') {
            nextPane.classList.add('animateInLeft');
            previousPane.classList.add('animateOutRight');
            setTimeout(function () {
                nextPane.classList.remove('animateInLeft');
                previousPane.classList.remove('animateOutRight');
            }, TRANSITION_TIMING);
        }
        if (direction == 'NEXT') {
            nextPane.classList.add('animateInRight');
            previousPane.classList.add('animateOutLeft');
            setTimeout(function () {
                nextPane.classList.remove('animateInRight');
                previousPane.classList.remove('animateOutLeft');
            }, TRANSITION_TIMING);
        }
    };
    var updateActivePane = function (state, update) {
        var nextStep = update.activeStep;
        var nextPane = document.querySelector('[data-advisor-step="' + nextStep + '"]');
        var previousPane = state.activePaneElement;
        if (nextPane === previousPane || !nextPane || !previousPane) {
            return;
        }
        var direction = state.activeStep > update.activeStep ? 'PREV' : 'NEXT';
        animatePaneTransition(previousPane, nextPane, direction);
        return;
    };
    var updateFrameHeight = function (state, update) {
        var newPane = update.activePaneElement;
        var height = newPane.getBoundingClientRect().height;
        var PADDING = 60;
        paneFrame.style.height = (height + PADDING) + 'px';
    };
    state_1.subscribe('activePaneElement', updateFrameHeight);
    state_1.subscribe('activeStep', updateActivePane);
});
